(() => {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const OEE_PATH_RE = /\/oee(?:\/|$|\?)/i;
  const REMINDER_KEY_PREFIX = "sip_oee_reminder_closed_";
  const STYLE_ID = "sip-oee-master-search-reminder-style-v1";

  const isOeePage = () =>
    OEE_PATH_RE.test(`${window.location.pathname}${window.location.search}`);

  const norm = (v) =>
    String(v || "").toLowerCase().replace(/\s+/g, " ").trim();

  const visible = (el) => {
    if (!el || !el.isConnected) return false;
    const cs = window.getComputedStyle(el);
    return cs.display !== "none" && cs.visibility !== "hidden";
  };

  const localDateKey = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
      d.getDate()
    ).padStart(2, "0")}`;
  };

  const reminderKey = () => `${REMINDER_KEY_PREFIX}${localDateKey()}`;

  const reminderClosedToday = () => {
    try {
      return window.localStorage.getItem(reminderKey()) === "1";
    } catch (_) {
      return false;
    }
  };

  const rememberReminderClosed = () => {
    try {
      Object.keys(window.localStorage || {}).forEach((k) => {
        if (k.startsWith(REMINDER_KEY_PREFIX) && k !== reminderKey()) {
          window.localStorage.removeItem(k);
        }
      });
      window.localStorage.setItem(reminderKey(), "1");
    } catch (_) {}
  };

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      .sip-oee-master-filter-v1{
        display:grid;grid-template-columns:minmax(220px,1fr) minmax(220px,1fr) auto;
        gap:10px;align-items:end;padding:10px 12px;margin:10px 0 8px;
        border:1px solid #d8e2ef;border-radius:10px;background:#f8fbff
      }
      .sip-oee-master-filter-v1 label{
        display:block;margin:0 0 4px;color:#334155;font-size:12px;font-weight:800
      }
      .sip-oee-master-filter-v1 input{
        width:100%;min-height:36px;box-sizing:border-box;padding:7px 10px;
        border:1px solid #bfcde0;border-radius:8px;background:#fff;color:#111827;
        font-size:13px;outline:none
      }
      .sip-oee-master-filter-v1 input:focus{
        border-color:#2563eb;box-shadow:0 0 0 3px rgba(37,99,235,.12)
      }
      .sip-oee-filter-count{
        min-width:110px;padding:8px 10px;border-radius:8px;background:#e8f1ff;
        color:#1e40af;font-size:12px;font-weight:900;text-align:center;white-space:nowrap
      }
      .sip-oee-filter-empty-v1{
        display:none;padding:10px 12px;margin:0 0 8px;border:1px dashed #cbd5e1;
        border-radius:8px;background:#fff;color:#64748b;font-size:12px;font-weight:700;
        text-align:center
      }
      [data-sip-oee-reminder-card-v1="1"]{position:relative!important}
      .sip-oee-reminder-close-v1{
        position:absolute!important;top:6px!important;right:6px!important;z-index:99999!important;
        width:27px!important;height:27px!important;min-width:27px!important;padding:0!important;
        border:1px solid #cbd5e1!important;border-radius:999px!important;background:#fff!important;
        color:#334155!important;box-shadow:0 2px 7px rgba(15,23,42,.14)!important;
        font-size:17px!important;line-height:23px!important;font-weight:900!important;cursor:pointer!important
      }
      .sip-oee-reminder-close-v1:hover{
        background:#fee2e2!important;border-color:#fca5a5!important;color:#b91c1c!important
      }
      @media(max-width:800px){
        .sip-oee-master-filter-v1{grid-template-columns:1fr}
        .sip-oee-filter-count{text-align:left}
      }
    `;
    document.head.appendChild(style);
  }

  function findMasterPanels() {
    return Array.from(document.querySelectorAll("table"))
      .map((table) => {
        let p = table.parentElement;
        let hops = 0;

        while (p && p !== document.body && hops < 8) {
          const text = norm(p.innerText);
          if (
            text.includes("crud master oee") &&
            text.includes("data master") &&
            (text.includes("simpan master") || text.includes("tambah master baru"))
          ) {
            return { panel: p, table };
          }
          p = p.parentElement;
          hops += 1;
        }

        return null;
      })
      .filter(Boolean)
      .filter(({ panel }) => visible(panel));
  }

  function applyMasterFilter(panel, table) {
    const filter = panel.querySelector(".sip-oee-master-filter-v1");
    if (!filter) return;

    const qName = norm(filter.querySelector('[data-sip-oee-filter-name-v1="1"]')?.value);
    const qCode = norm(filter.querySelector('[data-sip-oee-filter-code-v1="1"]')?.value);
    const rows = Array.from(table.querySelectorAll("tbody tr"));

    let shown = 0;

    rows.forEach((row) => {
      const cells = Array.from(row.cells || []);
      const dataText = norm(
        cells.length >= 2
          ? cells.slice(1, -1).map((c) => c.innerText).join(" ")
          : row.innerText
      );

      const match = (!qName || dataText.includes(qName)) && (!qCode || dataText.includes(qCode));
      row.style.display = match ? "" : "none";
      if (match) shown += 1;
    });

    const count = filter.querySelector('[data-sip-oee-filter-count-v1="1"]');
    if (count) count.textContent = `${shown} / ${rows.length} data`;

    const empty = panel.querySelector('[data-sip-oee-filter-empty-v1="1"]');
    if (empty) {
      empty.style.display = rows.length > 0 && shown === 0 ? "block" : "none";
    }
  }

  function installMasterFilter(panel, table) {
    let filter = panel.querySelector(".sip-oee-master-filter-v1");

    if (!filter) {
      filter = document.createElement("div");
      filter.className = "sip-oee-master-filter-v1";
      filter.innerHTML = `
        <div>
          <label>Cari Nama Part</label>
          <input type="text" data-sip-oee-filter-name-v1="1"
            placeholder="Ketik nama part..." autocomplete="off" />
        </div>
        <div>
          <label>Cari Kode FG / Kode Part</label>
          <input type="text" data-sip-oee-filter-code-v1="1"
            placeholder="Ketik kode FG / kode part..." autocomplete="off" />
        </div>
        <div class="sip-oee-filter-count" data-sip-oee-filter-count-v1="1">0 data</div>
      `;

      const empty = document.createElement("div");
      empty.className = "sip-oee-filter-empty-v1";
      empty.setAttribute("data-sip-oee-filter-empty-v1", "1");
      empty.textContent = "Data Master tidak ditemukan.";

      table.parentNode.insertBefore(filter, table);
      table.parentNode.insertBefore(empty, table);

      filter.querySelector('[data-sip-oee-filter-name-v1="1"]')
        ?.addEventListener("input", () => applyMasterFilter(panel, table));
      filter.querySelector('[data-sip-oee-filter-code-v1="1"]')
        ?.addEventListener("input", () => applyMasterFilter(panel, table));
    }

    applyMasterFilter(panel, table);
  }

  // SIP_OEE_REMINDER_CLOSE_V2
  const REMINDER_CLOSE_V2_ID = "sip-oee-reminder-close-v2";
  const REMINDER_CLOSE_V2_STYLE_ID = "sip-oee-reminder-close-v2-style";

  function ensureReminderCloseV2Style() {
    if (document.getElementById(REMINDER_CLOSE_V2_STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = REMINDER_CLOSE_V2_STYLE_ID;
    style.textContent = `
      #${REMINDER_CLOSE_V2_ID}{
        position:fixed!important;
        z-index:2147483647!important;
        width:30px!important;
        height:30px!important;
        min-width:30px!important;
        min-height:30px!important;
        padding:0!important;
        margin:0!important;
        border:1px solid #cbd5e1!important;
        border-radius:999px!important;
        background:#ffffff!important;
        color:#334155!important;
        box-shadow:0 3px 10px rgba(15,23,42,.20)!important;
        font-family:Arial,sans-serif!important;
        font-size:19px!important;
        font-weight:900!important;
        line-height:27px!important;
        text-align:center!important;
        cursor:pointer!important;
        pointer-events:auto!important;
        touch-action:manipulation!important;
        user-select:none!important;
        -webkit-user-select:none!important;
      }
      #${REMINDER_CLOSE_V2_ID}:hover{
        background:#fee2e2!important;
        border-color:#f87171!important;
        color:#b91c1c!important;
      }
      .sip-oee-reminder-close-v1{
        display:none!important;
        pointer-events:none!important;
      }
    `;
    document.head.appendChild(style);
  }

  function reminderCandidateScore(el) {
    if (!el || !el.isConnected || !visible(el)) return null;

    const text = norm(el.innerText);
    if (!text.includes("reminder input produksi") || !text.includes("jam")) {
      return null;
    }

    const rect = el.getBoundingClientRect();

    if (rect.width < 240 || rect.height < 55) return null;
    if (rect.width > Math.min(window.innerWidth * 0.65, 900)) return null;
    if (rect.height > Math.min(window.innerHeight * 0.55, 500)) return null;

    const usefulText =
      text.includes("belum lengkap") ||
      text.includes("berikutnya") ||
      text.includes("jam 1");

    return {
      el,
      score: rect.width * rect.height + (usefulText ? 0 : 10000000)
    };
  }

  function findReminderCard() {
    const raw = Array.from(document.querySelectorAll("div,section,aside"))
      .filter((el) => {
        const t = norm(el.innerText);
        return t.includes("reminder input produksi") && t.includes("jam");
      });

    if (!raw.length) return null;

    const unique = new Set();

    raw.forEach((el) => {
      let cur = el;
      let hops = 0;

      while (cur && cur !== document.body && hops < 7) {
        unique.add(cur);
        cur = cur.parentElement;
        hops += 1;
      }
    });

    const ranked = Array.from(unique)
      .map(reminderCandidateScore)
      .filter(Boolean)
      .sort((a, b) => a.score - b.score);

    if (ranked.length) return ranked[0].el;

    raw.sort(
      (a, b) =>
        norm(a.innerText).length -
        norm(b.innerText).length
    );

    return raw[0] || null;
  }

  function hideReminder(card) {
    if (!card) return;

    card.setAttribute("data-sip-oee-reminder-closed-v2", "1");
    card.style.setProperty("display", "none", "important");
    card.style.setProperty("visibility", "hidden", "important");
    card.style.setProperty("pointer-events", "none", "important");
  }

  function removeReminderCloseV2() {
    document.getElementById(REMINDER_CLOSE_V2_ID)?.remove();
  }

  function positionReminderCloseV2(button, card) {
    if (!button || !card || !card.isConnected) return;

    const rect = card.getBoundingClientRect();

    const top = Math.max(4, Math.round(rect.top + 6));
    const left = Math.max(
      4,
      Math.min(
        window.innerWidth - 34,
        Math.round(rect.right - 36)
      )
    );

    button.style.setProperty("top", `${top}px`, "important");
    button.style.setProperty("left", `${left}px`, "important");
    button.style.setProperty("right", "auto", "important");
  }

  function installReminderClose() {
    ensureReminderCloseV2Style();

    document
      .querySelectorAll(".sip-oee-reminder-close-v1")
      .forEach((el) => el.remove());

    const card = findReminderCard();

    if (!card) {
      removeReminderCloseV2();
      return;
    }

    card.setAttribute("data-sip-oee-reminder-card-v2", "1");

    if (reminderClosedToday()) {
      hideReminder(card);
      removeReminderCloseV2();
      return;
    }

    let button = document.getElementById(REMINDER_CLOSE_V2_ID);

    if (!button) {
      button = document.createElement("button");
      button.id = REMINDER_CLOSE_V2_ID;
      button.type = "button";
      button.title = "Tutup reminder sampai besok";
      button.setAttribute(
        "aria-label",
        "Tutup reminder sampai besok"
      );
      button.textContent = "×";

      const stopOnly = (event) => {
        event.stopPropagation();
      };

      button.addEventListener("pointerdown", stopOnly, true);
      button.addEventListener("mousedown", stopOnly, true);
      button.addEventListener("touchstart", stopOnly, true);

      button.addEventListener(
        "click",
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (typeof event.stopImmediatePropagation === "function") {
            event.stopImmediatePropagation();
          }

          rememberReminderClosed();

          const currentCard =
            findReminderCard() ||
            document.querySelector(
              '[data-sip-oee-reminder-card-v2="1"]'
            );

          hideReminder(currentCard);
          removeReminderCloseV2();

          console.info(
            "[SIP OEE] Reminder ditutup sampai hari berikutnya."
          );
        },
        true
      );

      document.body.appendChild(button);
    }

    positionReminderCloseV2(button, card);
  }

  let timer = null;

  function installAll() {
    if (!isOeePage()) return;
    addStyles();
    findMasterPanels().forEach(({ panel, table }) => installMasterFilter(panel, table));
    installReminderClose();
  }

  function scheduleInstall() {
    window.clearTimeout(timer);
    timer = window.setTimeout(installAll, 80);
  }

  function start() {
    installAll();

    const observer = new MutationObserver(scheduleInstall);
    observer.observe(document.body, { childList: true, subtree: true });

    ["popstate", "hashchange"].forEach((evt) =>
      window.addEventListener(evt, scheduleInstall)
    );

    window.addEventListener("resize", scheduleInstall);
    window.addEventListener("scroll", scheduleInstall, true);

    ["pushState", "replaceState"].forEach((method) => {
      const original = window.history[method];
      if (typeof original !== "function") return;

      window.history[method] = function (...args) {
        const result = original.apply(this, args);
        scheduleInstall();
        return result;
      };
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
